import React, { useState } from 'react';
import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';

const slidesData = [
    {
        id: 1,
        title: "Next-Gen Decentralized Cloud Infrastructures ",
        text: "Makers Lab is shaping the future of cloud with next-gen decentralized infrastructure that is fast, secure, and scalable. We empower developers and businesses with true data ownership, distributed computing, and seamless collaboration. Built for Web3 and AI, our ecosystem makes cloud technology more open, resilient, and accessible for everyone.",
        image: "/assets/lab/img5.png",
        link: "#"
    },
    {
        id: 2,
        title: "Building Solutions with AI for the health Sector",
        text: "Makers labs builds practical AI solutions for the healthcare sector, helping doctors and hospitals improve patient care, speed up diagnosis, and manage operations more easily. We focus on simple, reliable, and scalable technology that supports better decisions and outcomes. Our goal is to make healthcare smarter, faster and accessible for everyone. ",
        image: "/assets/lab/img5.png",
        link: "#"
    },
    {
        id: 3,
        title: "Revolutionizing Financial Models using Quantum Computing ",
        text: "Mobikode, in collaboration with Makers Labs, is reshaping how financial models work using quantum computing. We’re making forecasting faster, risk analysis smarter, and decisions more reliable. By combining advanced quantum algorithms with real-world finance, we’re helping businesses move beyond traditional methods into a new era of intelligent, data-driven financial systems.",
        image: "/assets/lab/img5.png",
        link: "#"
    }
];

export default function IndustryFirstsSection() {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [loaded, setLoaded] = useState(false);

    const [sliderRef, instanceRef] = useKeenSlider(
        {
            initial: 0,
            loop: true,
            slideChanged(slider) {
                setCurrentSlide(slider.track.details.rel);
            },
            created() {
                setLoaded(true);
            },
            slides: { perView: 1, spacing: 0 },
        },
        [
            (slider) => {
                let timeout;
                let mouseOver = false;

                function clearNextTimeout() {
                    clearTimeout(timeout);
                }

                function nextTimeout() {
                    clearTimeout(timeout);
                    if (mouseOver) return;
                    timeout = setTimeout(() => {
                        slider.next();
                    }, 3000);
                }

                slider.on("created", () => {
                    slider.container.addEventListener("mouseover", () => {
                        mouseOver = true;
                        clearNextTimeout();
                    });
                    slider.container.addEventListener("mouseleave", () => {
                        mouseOver = false;
                        nextTimeout();
                    });
                    nextTimeout();
                });
                slider.on("dragStarted", clearNextTimeout);
                slider.on("animationEnded", nextTimeout);
                slider.on("updated", nextTimeout);
            },
        ]
    );

    return (
        <section className="w-full pb-[40px] md:pb-[100px] overflow-hidden font-sora bg-white">
            <div className="max-w-[1440px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-y-8 md:gap-x-12 lg:gap-x-16 px-[20px] md:px-[40px] lg:px-[80px]">

                <div className="md:col-span-7">
                    <div className="mb-[24px] md:mb-[60px]">
                        <h2 className="text-[20px] md:text-[30px] font-[600] text-[#01386A] tracking-tight">
                            Some of the Firsts in the Industry
                        </h2>
                    </div>
                    <div className="max-w-[520px] w-full overflow-hidden mx-auto shadow-sm">
                        <div ref={sliderRef} className="keen-slider">
                            {slidesData.map((slide) => (
                                <div key={slide.id} className="keen-slider__slide relative">
                                    <img
                                        src={slide.image}
                                        alt={slide.title}
                                        className="w-full h-[240px] sm:h-[300px] md:h-[320px] object-cover transition-transform duration-700 ease-out md:hover:scale-105 select-none"
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="md:col-span-5 flex flex-col justify-center space-y-5 sm:space-y-6 md:mt-[105px]">

                    <div className="flex flex-col gap-3">
                        <h3 className="text-[15px] md:text-[20px] font-[600] text-[#01386A] leading-tight max-w-sm transition-all duration-300">
                            {slidesData[currentSlide]?.title}
                        </h3>

                        <p className="text-[#6C7689] font-graphik text-[14px] sm:text-[16px] leading-[1.6] font-[500] max-w-md transition-all duration-300">
                            {slidesData[currentSlide]?.text}
                        </p>
                    </div>

                    <div className="group inline-block w-fit">
                        <a
                            href={slidesData[currentSlide]?.link}
                            className="inline-flex items-center text-[14px] lg:text-[16px] font-[600] text-[#01386A] tracking-wide font-sora transition-all duration-300"
                        >
                            <span className="relative font-graphik after:absolute after:bottom-0 after:left-0 after:h-[1.5px] after:w-full after:origin-bottom-right after:scale-x-0 after:bg-[#01386A] after:transition-transform after:duration-300 group-hover:after:origin-bottom-left group-hover:after:scale-x-100 pb-0.5">
                                Read More
                            </span>

                            <svg
                                className="w-4 h-4 ml-2 text-[#F97316] transition-transform duration-300 ease-out transform group-hover:translate-x-1.5"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.5"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M9 5l7 7-7 7" />
                            </svg>
                        </a>
                    </div>

                    {loaded && instanceRef.current && (
                        <div className="flex items-center gap-4 pt-2">
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    instanceRef.current?.prev();
                                }}
                                className="w-10 h-10 rounded-full border border-[#F97316] text-[#F97316] hover:bg-[#F97316] hover:text-white flex items-center justify-center transition-colors duration-300"
                                aria-label="Previous slide"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M19 12H5M12 19l-7-7 7-7" />
                                </svg>
                            </button>

                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    instanceRef.current?.next();
                                }}
                                className="w-10 h-10 rounded-full border border-[#F97316] text-[#F97316] hover:bg-[#F97316] hover:text-white flex items-center justify-center transition-colors duration-300"
                                aria-label="Next slide"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M5 12h14M12 5l7 7-7 7" />
                                </svg>
                            </button>
                        </div>
                    )}

                </div>
            </div>
        </section>
    );
}